// Utilidades de ordenamiento para las tablas de las planillas.

// Normaliza Timestamps de Firestore y objetos Date a milisegundos; el resto
// de los valores se devuelven tal cual. Los vacíos se mapean a null.
const toComparable = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value?.toDate === 'function') return value.toDate().getTime();
  if (value instanceof Date) return value.getTime();
  return value;
};

// Indica si un valor puede compararse numéricamente. Los montos suelen
// almacenarse como strings ("1500000"), por lo que también se contemplan.
const isNumericValue = (value) => {
  if (typeof value === 'number') return Number.isFinite(value);
  if (typeof value === 'string' && value.trim() !== '') return Number.isFinite(Number(value));
  return false;
};

// Comparador genérico para ordenar filas: numérico cuando ambos valores son
// números (o strings numéricos) y alfabético en español en caso contrario.
// Los valores vacíos quedan siempre al final, sin importar la dirección.
export const compareValues = (rawA, rawB, direction = 'ascending') => {
  const a = toComparable(rawA);
  const b = toComparable(rawB);

  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  const comparison = isNumericValue(a) && isNumericValue(b)
    ? Number(a) - Number(b)
    : String(a).localeCompare(String(b), 'es', { numeric: true, sensitivity: 'base' });

  return direction === 'ascending' ? comparison : -comparison;
};
